const RegexFieldTypeEnum = Object.freeze({
    Numberic: "numberic",
    Date: "date",
    Money: "money",
  });
  
  export default RegexFieldTypeEnum;